import SEO from "@/components/SEO";
import PageHero from "@/components/sections/PageHero";
import CTASection from "@/components/sections/CTASection";
import { Reveal, StaggerGroup, staggerItem } from "@/components/motion/Reveal";
import { motion } from "framer-motion";
import { Eyebrow, SectionHeading } from "@/components/primitives";
import { values, brand } from "@/content/site";

export default function About() {
  return (
    <>
      <SEO
        title="About Green Circle Group | Digital Growth for Australian Trades"
        description="Green Circle Group helps busy Australian trade businesses grow beyond the owner's available time by connecting visibility, leads, follow-up and systems."
        path="/about"
      />
      <PageHero
        eyebrow="About"
        heading="Helping good trade businesses grow beyond the owner's available time."
        copy="Green Circle Group was created to help busy Australian businesses grow and transform in the digital age."
        breadcrumbs={[
          { label: "Home", to: "/" },
          { label: "About", to: "/about" },
        ]}
      />

      <section className="bg-white pb-8">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal className="text-lg text-mid-neutral leading-relaxed">
            Trade business owners are often expected to be the technician,
            manager, salesperson, marketer and strategist at the same time.
            Green Circle Group puts an experienced digital growth capability around
            the business so important growth activity no longer depends on
            whatever time the owner has left at the end of the day.
          </Reveal>
        </div>
      </section>

      {/* Belief */}
      <section className="bg-forest py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <Eyebrow dark>Our belief</Eyebrow>
          <SectionHeading dark className="mt-5">
            Growth works better when the whole circle is connected.
          </SectionHeading>
          <p className="mt-6 text-lg text-white/80 leading-relaxed">
            Visibility creates enquiries. Enquiries require fast, consistent
            follow-up. Good customer experiences create jobs, reviews and
            referrals. Better information helps the business decide what to
            improve next.
          </p>
          <p className="mt-4 text-lg text-white/80 leading-relaxed">
            Green Circle Group connects those parts into a managed system.
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="bg-soft py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Eyebrow>Values</Eyebrow>
          <SectionHeading className="mt-5">What guides our work</SectionHeading>
          <StaggerGroup className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {values.map((v) => (
              <motion.div
                key={v.title}
                variants={staggerItem}
                className="rounded-[1.5rem] bg-white border border-border-neutral p-7"
              >
                <h3 className="text-xl font-extrabold text-forest">{v.title}</h3>
                <p className="mt-2 text-mid-neutral leading-relaxed">{v.desc}</p>
              </motion.div>
            ))}
          </StaggerGroup>

          <p className="mt-12 text-sm text-mid-neutral max-w-3xl">
            {brand.owner} (ABN {brand.abn}).
          </p>
        </div>
      </section>

      <CTASection />
    </>
  );
}
